import { createFileRoute } from "@tanstack/react-router";
import DrivewayPatioPavers from "@/pages/DrivewayPatioPavers";
import { buildHead } from "@/lib/seo";

const areaServed = [
  { "@type": "City", name: "Fort Lauderdale" },
  { "@type": "City", name: "Coral Springs" },
  { "@type": "City", name: "Pembroke Pines" },
  { "@type": "City", name: "Weston" },
  { "@type": "City", name: "Miramar" },
  { "@type": "City", name: "Sunrise" },
  { "@type": "City", name: "Davie" },
  { "@type": "City", name: "Miami" },
  { "@type": "City", name: "Tampa" },
  { "@type": "City", name: "Orlando" },
];

export const Route = createFileRoute("/services/driveway-patio-pavers")({
  head: () =>
    buildHead({
      title:
        "Driveway & Patio Pavers in Broward County, FL | Precision Pavers & Pool Design",
      description:
        "Premium driveway paving, patio installation, and walkway resurfacing in Fort Lauderdale, Coral Springs, Weston, and across Broward County. Tremron and Belgard materials. Family-owned. Free estimates.",
      path: "/services/driveway-patio-pavers",
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "Service",
          serviceType: "Driveway & Patio Pavers",
          provider: {
            "@type": "HomeAndConstructionBusiness",
            name: "Precision Pavers & Pool Design",
            url: "https://precisionpaverspools.com/",
          },
          areaServed,
          url: "https://precisionpaverspools.com/services/driveway-patio-pavers",
          description:
            "Expert Driveway & Patio Pavers services in Broward County, FL. Free estimates.",
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://precisionpaverspools.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Services",
              item: "https://precisionpaverspools.com/services",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "Driveway & Patio Pavers",
              item: "https://precisionpaverspools.com/services/driveway-patio-pavers",
            },
          ],
        },
      ],
    }),
  component: DrivewayPatioPavers,
});
